import * as $ from "jquery";

export default class SearchArticlesComponent {
    constructor() {
        this.componentSelector = "#report-search-articles";
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('.js-search-articles').off().on('click', function () {
            instance.run(instance);
        });

        $('.js-download-excel').off().on('click', function () {
            instance.download(instance);
        });
    }

    run(instance) {
        let query = $('#query').val();

        axios({
            method: 'post',
            url: "/report/getarticlelist",
            data: { sysIds: query }
        }).then(function (response) {
            $('#report-result').html(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }

    download(instance) {
        var uri = "/report/GetArticleListAsExcel";

        var date = new Date();
        var cache = date.getUTCFullYear() + date.getUTCMonth() + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes() + date.getUTCSeconds() + date.getUTCMilliseconds();
        var fileName = "HeadBrands-artiklar-" + date.toISOString().split('T')[0] + ".xlsx";

        let query = $('#query').val();

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };

        /*
        var params = JSON.stringify({ sysIds: query });
        x.setRequestHeader("Content-length", params.length);
        x.send(params);
        */

        var data = new FormData();
        data.append('sysIds', query);
        x.send(data);

        if (typeof (callback) === 'function')
            callback();
    }
}